<template>
    <div class="content-i">
        <div class="content-box">
            <div class="element-box">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div class="logo-w">
                            <a href="/">
                                <img v-if="!this.missingImage && allTemplateDetails.loginLogoImage" @error="imageError()" :alt="allTemplateDetails.name" width="100%" :src="allTemplateDetails.loginLogoImage">
                                <img v-else :alt="allTemplateDetails.name" width="100%" :src="allTemplateDetails.loginLogoImage">
                            </a>
                        </div>
                    </div>
                    <hr />
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <h1 align="center"><i class="os-icon os-icon-cancel-circle"></i>404</h1>
                        <h1 align="center">{{ t('pageNotFound', 'pageNotFound') }}</h1>
                    </div>
                </div>
            </div>  
        </div>
    </div>
</template>
<script>
export default{
  name: 'pagenotfound',
  data() {
      return {
          missingImage: false,
      }
  },
  methods:{
      changeBackgroud(){
        document.body.style.backgroundImage = "url("+this.$store.getters.allTemplateDetails.loginBackgroundImage+"),  linear-gradient(to top, #00c6fb 0%, #005bea 100%)"
      },
      imageError() {
        this.missingImage = true
      }
  },
  created(){
      this.changeBackgroud()   
  },
  computed: {
      ...mapGetters(['allTemplateDetails'])
  }
}
</script>

<style scoped>
    .main {
        text-align: center;
        font-size: 48px;
        font-weight: 600;
        margin: 120px;
    }
</style>